/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

// @ts-expect-error TS2307
import { Parser } from 'saxen';

import { BPMN, DMN } from 'utils/constants';

const BPMN_NAMESPACE_URIS = ['http://www.omg.org/spec/BPMN'];

const DMN_NAMESPACE_URIS = ['http://www.omg.org/spec/DMN/', 'https://www.omg.org/spec/DMN/'];

/**
 * Get the namespace URI from the definitions element of a BPMN or DMN XML.
 *
 * @param {string} contents
 *
 * @returns {string|null}
 */
function getNamespaceUriFromDefinitions(contents) {
  let namespaceUri = null;

  const parser = new Parser();

  parser.on('error', () => {
    parser.stop();
  });

  parser.on('openTag', (elementName, getAttributes) => {
    // namespaces with prefix (<bpmn:definitions> or <dmn:definitions>)
    if (elementName.includes(':')) {
      const [prefix, name] = elementName.split(':');

      if (name.toLowerCase() === 'definitions') {
        namespaceUri = getAttributes()[`xmlns:${prefix}`];
      }
    }
    // default namespace (<definitions>)
    else {
      if (elementName.toLowerCase() === 'definitions') {
        namespaceUri = getAttributes().xmlns;
      }
    }

    parser.stop();
  });

  parser.parse(contents);

  return namespaceUri;
}

/**
 * Get the diagram type from the namespace URI of a BPMN or DMN XML.
 *
 * @param {string} xml
 *
 * @returns {string|null}
 */
export function getDiagramTypeFromNamespaceUri(xml) {
  if (!xml) {
    return null;
  }

  const namespaceUri = getNamespaceUriFromDefinitions(xml);

  if (!namespaceUri) {
    return null;
  }

  if (BPMN_NAMESPACE_URIS.some((uri) => namespaceUri.startsWith(uri))) {
    return BPMN;
  } else if (DMN_NAMESPACE_URIS.some((uri) => namespaceUri.startsWith(uri))) {
    return DMN;
  }

  return null;
}
